import { ticketApi } from "./api";
import type {
  TicketTypeResponse,
  // LinkedUserStoryResponse,
  // ProjectBoardResponseType,
  ProjectRequestType
} from "@/types";
import { GitLabTicketGeneratorService } from "../intranet-portal-services/services/GitLabTicketGeneratorService";
import type { IntranetPortal_GitLabTicketGenerator_Dtos_ProjectDto } from "../intranet-portal-services/models/IntranetPortal_GitLabTicketGenerator_Dtos_ProjectDto";
import type { IntranetPortal_GitLabTicketGenerator_Dtos_GetGitLabIssueDto } from "../intranet-portal-services/models/IntranetPortal_GitLabTicketGenerator_Dtos_GetGitLabIssueDto";
import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import {
  IntranetPortal_GitLabTicketGenerator_Dtos_PostGitLabTicketInputDto,
  IntranetPortal_GitLabTicketGenerator_Dtos_PostGitLabTicketResultDto,
  IntranetPortal_GitLabTicketGenerator_Dtos_TicketTypeDto
} from "../intranet-portal-services";

const ticketGeneratorApis = ticketApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * get project boards list
     * this apis service is used to get the project (repository) list
     */
    getProjectBoards: builder.query<
      IntranetPortal_GitLabTicketGenerator_Dtos_ProjectDto[],
      ProjectRequestType
    >({
      queryFn: async ({ searchName }: ProjectRequestType) => {
        try {
          const response =
            await GitLabTicketGeneratorService.getCoreApiApiAppGitLabTicketGeneratorUserProjects(
              searchName
            );
          return { data: response };
          // return { data: response.data };
        } catch (error) {
          return { error: error as FetchBaseQueryError };
        }
      },
      providesTags: ["ProjectBoards"],
      keepUnusedDataFor: 300
    }),

    /**
     * get ticket types
     * this apis service is used to get the ticket types
     */
    getTicketTypes: builder.query<IntranetPortal_GitLabTicketGenerator_Dtos_TicketTypeDto[], void>({
      queryFn: async () => {
        try {
          const response =
            await GitLabTicketGeneratorService.getCoreApiApiAppGitLabTicketGeneratorTicketTypes();
          return { data: response };
        } catch (error) {
          return { error: error as FetchBaseQueryError };
        }
      }
    }),

    /**
     * get user stories in project
     * This apis service is used to get the user stories in the project
     */
    getUserStories: builder.query<
      IntranetPortal_GitLabTicketGenerator_Dtos_GetGitLabIssueDto[],
      number
    >({
      queryFn: async (projectId: number) => {
        try {
          const response =
            await GitLabTicketGeneratorService.getCoreApiApiAppGitLabTicketGeneratorUserStoriesInProject(
              projectId
            );
          return { data: response };
        } catch (error) {
          return { error: error as FetchBaseQueryError };
        }
      },
      providesTags: ["userStories"],
      keepUnusedDataFor: 300
    }),

    /**postTicketPayloadToGitLab
     * this apis service is to post the payload for the GiTLab
     * **/
    postTicketPayloadToGitLab: builder.mutation<IntranetPortal_GitLabTicketGenerator_Dtos_PostGitLabTicketResultDto, IntranetPortal_GitLabTicketGenerator_Dtos_PostGitLabTicketInputDto>({
      queryFn: async (payload) => {
        try {
          const response =
            await GitLabTicketGeneratorService.postCoreApiApiAppGitLabTicketGeneratorGitLabTicket(
              payload
            );
          return { data: response };
        } catch (error) {
          return { error: error as FetchBaseQueryError };
        }
      },
      invalidatesTags: ["userStories"]
    })
  }),
  overrideExisting: false
});

export const {
  useGetProjectBoardsQuery,
  useGetTicketTypesQuery,
  useGetUserStoriesQuery,
  usePostTicketPayloadToGitLabMutation
} = ticketGeneratorApis;
